import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { isCampanhaClienteVisualizacaoModoAmbos, isCampanhaClienteVisualizacaoModoAquisicoes, isCampanhaClienteVisualizacaoModoOrigens } from '../visualizacao-modo';
import { CampanhaClienteFilter } from './campanha-cliente-filter';

@Component({
    selector: 'sgt-campanha-cliente-filter',
    templateUrl: './campanha-cliente-filter.component.html',
    styleUrls: ['./campanha-cliente-filter.component.less']
})
export class CampanhaClienteFilterComponent implements OnInit {
    @Input() idCampanha: number;
    @Input() filter: CampanhaClienteFilter;
    @Output() filterChange = new EventEmitter<any>();

    // Mulstiselects
    isFirstChangeClassificacoesMultiselect = true;
    isFirstChangeRepresentanteMultiselect = true;

    ngOnInit(): void {
        this.setIDCampanhaByModoVisualizacao();
    }

    /** Seta o ID da campanha informada no filtro das campanhas dos clientes conforme o modo de visualização das campanhas */
    private setIDCampanhaByModoVisualizacao() {
        this.filter.idsCampanhasOrigens = [];
        this.filter.idsCampanhasAquisicoes = [];
        this.filter.idsCampanhasOrigensAquisicoes = [];
        if (isCampanhaClienteVisualizacaoModoOrigens(this.filter.visualizacaoModo)) { // Campanhas de Origens
            this.filter.idsCampanhasOrigens = [this.idCampanha];
        } else if (isCampanhaClienteVisualizacaoModoAquisicoes(this.filter.visualizacaoModo)) { // Campanhas de Aquisições
            this.filter.idsCampanhasAquisicoes = [this.idCampanha];
        } else if (isCampanhaClienteVisualizacaoModoAmbos(this.filter.visualizacaoModo)) { // Ambos
            this.filter.idsCampanhasOrigensAquisicoes = [this.idCampanha];
        }
    }

    /** Ao alterar o modo de visualização das campanhas, setamos a campanha no filtro correto das campanhas dos clientes */
    onChangeModoVisualizacao(visualizacaoModo: number) {
        this.filter.visualizacaoModo = visualizacaoModo;
        this.setIDCampanhaByModoVisualizacao();
        this.filterChange.emit();
    }

    /** Ao alterar os cadastros */
    onChangeCadastros() {
        this.filterChange.emit();
    }

    /** Ao alterar as situações */
    onChangeSituacoes() {
        this.filterChange.emit();
    }

    /** Ao alterar as classificações */
    onChangeClassificacoes() {
        if (this.isFirstChangeClassificacoesMultiselect) {
            this.isFirstChangeClassificacoesMultiselect = false;
            return;
        }
        this.filterChange.emit();
    }

    /** Ao alterar os representantes */
    onChangeRepresentantes() {
        if (this.isFirstChangeRepresentanteMultiselect) {
            this.isFirstChangeRepresentanteMultiselect = false;
            return;
        }
        this.filterChange.emit();
    }

    /** Limpa o filtro */
    clear() {
        this.filter.clear();
        this.setIDCampanhaByModoVisualizacao();

        setTimeout(() => this.filterChange.emit(), 0);
    }
}
